import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { Permission } from '@utils/types/folders/folder.ts';
import { PUT_URL } from '@utils/api/endpoints.ts';

export interface UpdateFolderNameMutationParams {
  name: string;
  folder_id: number;
  permissions: Permission[];
  parent_id: number | null;
}

export function useUpdateFolder() {
  const queryClient = useQueryClient();

  return useMutation(
    (payload: UpdateFolderNameMutationParams) =>
      Axios.put(PUT_URL(payload.folder_id.toString()).updateFolder, {
        name: payload.name,
        permissions: payload.permissions,
        parent_id: payload.parent_id
      }).then(res => res.data),
    {
      onSuccess: () => {
        // Broad prefix invalidation: the folder list query is keyed
        // ['folders', 'all'|'folders_only', ...] and the single-folder
        // detail is keyed ['folder', ...]. Matching the exact composite
        // keys is brittle, so invalidate both families wholesale.
        queryClient.invalidateQueries('folders');
        queryClient.invalidateQueries('folder');
      },
      useErrorBoundary: false
    }
  );
}
